import { render, staticRenderFns } from "./BannerShopByBrandForm.vue?vue&type=template&id=4a638d86&scoped=true&"
import script from "./BannerShopByBrandForm.vue?vue&type=script&lang=js&"
export * from "./BannerShopByBrandForm.vue?vue&type=script&lang=js&"
import style0 from "./BannerShopByBrandForm.vue?vue&type=style&index=0&id=4a638d86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a638d86",
  null
  
)

export default component.exports